$(window).on('load resize', function () {
  let bannerHeight = 0;
  const headerHeight = $('#shopify-section-menu-bar').outerHeight();

  if ($('.banner').length) {
    if ($('.banner').css('display') != 'none') {
      bannerHeight = $('.banner').outerHeight();
    }
  }

  if (!$('.nav-blog-holder').hasClass('top')) {
    $('.section-blog, .section-article').css('padding-top', `${bannerHeight + headerHeight}px`);
  } else {
    $('.nav-blog-holder').css('margin-top', `${bannerHeight + headerHeight}px`);
  }
});
